import { useRef } from "react";
import { clockOf } from "../rules/format";
import { toneOf } from "../constants";

/*
 * The player's bar: the round's modules in their tones, what has played, the
 * recording's gaps hatched, a line where a session restarted, and a pin for every
 * flag. Dragging moves the clock without writing the address; letting go writes
 * one history entry.
 */
export default function Scrubber({ length, t, modules, gaps = [], flagged = [], restarts = [], onSeek, onPin }) {
  const L = Math.max(1, length);
  const pc = (x) => `${Math.max(0, Math.min(100, (x / L) * 100))}%`;
  const dragged = useRef(null);

  const move = (e) => {
    const v = Number(e.target.value);
    dragged.current = v;
    onSeek(v, { write: false });
  };
  const commit = () => {
    if (dragged.current == null) return;
    const v = dragged.current;
    dragged.current = null;
    onSeek(v);
  };

  return (
    <div className="proctoring-review__scrub">
      <div className="proctoring-review__scrub-mods" aria-hidden="true">
        {modules.map((m, i) => (
          <span key={`${m.key}-${m.from}`} style={{ left: pc(m.from), width: pc(m.to - m.from), background: toneOf(i).bar }} />
        ))}
        {gaps.map((g) => (
          <span key={`gap-${g.from}`} className="proctoring-review__scrub-gap" style={{ left: pc(g.from), width: pc(g.to - g.from) }} title={`Not recorded ${clockOf(g.from)} to ${clockOf(g.to)}`} />
        ))}
        {restarts.map((r) => (
          <span key={r.key} className="proctoring-review__scrub-restart" style={{ left: pc(r.at) }} title={`Session restarted at ${clockOf(r.at)}`} />
        ))}
        <span className="proctoring-review__scrub-done" style={{ width: pc(t) }} />
      </div>
      <input
        type="range"
        min={0}
        max={Math.round(L)}
        step={1}
        value={Math.min(Math.round(t), Math.round(L))}
        aria-label="Position in the round"
        aria-valuetext={clockOf(t)}
        onChange={move}
        onMouseUp={commit}
        onTouchEnd={commit}
        onKeyUp={commit}
        onBlur={commit}
      />
      {flagged.map((x) => (
        <button
          key={x.key}
          type="button"
          className={`proctoring-review__pin${x.severity === "critical" ? " proctoring-review__pin--critical" : ""}`}
          style={{ left: pc(x.at) }}
          onClick={() => onPin(x)}
          aria-label={`Go to ${clockOf(x.at)}: ${x.what}`}
          title={`${clockOf(x.at)} ${x.what}`}
        />
      ))}
    </div>
  );
}
